import { AppBar, Toolbar, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from './Styles';

export default function SwaAppBar() {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
          <AppBar className={clsx(classes.appBar)}
                  color="default"
                  >
              <div>
                <Toolbar className={classes.toolbar} >
                    <div>
                      <img src='swa-heart.png' alt="swa-heart" width='175px'/>
                    </div>
                    <Typography variant="h6" color="inherit" className={classes.typography} noWrap >
                        Inflight Training Admin App
                    </Typography>
                </Toolbar>
              </div>
          </AppBar>
        </div>);
}
